import WideDefaultLayout from "@layouts/WideDefaultLayout";

import { PolicyCard, Section } from "./PolicyStyles";

const TermsOfService = () => {
  return (
    <WideDefaultLayout
      pageTitle="이용약관"
      description="로아투두(LOATODO) 서비스 이용약관입니다."
    >
      <PolicyCard>
        <Section>
          <h2>로아투두(LOATODO) 이용약관</h2>
          <p>
            본 약관은 로아투두(LOATODO, 이하 &ldquo;서비스&rdquo;)의 이용에 관한 조건 및
            절차, 이용자와 서비스 제공자 간의 권리·의무를 규정합니다.
          </p>
        </Section>

        <Section>
          <h3>제1조 (목적)</h3>
          <p>
            본 약관은 로아투두가 제공하는 로스트아크 숙제 관리 서비스 및 관련
            부가 서비스(이하 &ldquo;서비스&rdquo;)의 이용에 관한 사항을 규정함을 목적으로
            합니다.
          </p>
        </Section>

        <Section>
          <h3>제2조 (정의)</h3>
          <ul>
            <li>
              &ldquo;서비스&rdquo;란 로아투두가 제공하는 웹 서비스 및 관련 부가 서비스를
              말합니다.
            </li>
            <li>
              &ldquo;이용자&rdquo;란 본 약관에 동의하고 서비스를 이용하는 자를 말합니다.
            </li>
            <li>
              &ldquo;회원&rdquo;이란 서비스에 회원가입을 하고 아이디를 부여받은 이용자를
              말합니다.
            </li>
            <li>
              &ldquo;구독 서비스&rdquo;란 월 정기결제를 통해 광고 제거 등 추가 혜택을
              제공하는 유료 서비스를 말합니다.
            </li>
          </ul>
        </Section>

        <Section>
          <h3>제3조 (약관의 효력 및 변경)</h3>
          <ul>
            <li>
              본 약관은 서비스 화면에 게시하거나 기타 방법으로 이용자에게
              공지함으로써 효력이 발생합니다.
            </li>
            <li>
              서비스는 관련 법령에 위배되지 않는 범위 내에서 약관을 변경할 수
              있으며, 변경 시 최소 7일 전에 공지합니다.
            </li>
          </ul>
        </Section>

        <Section>
          <h3>제4조 (서비스 내용)</h3>
          <p>서비스는 다음과 같은 기능을 제공합니다.</p>
          <ul>
            <li>로스트아크 캐릭터 숙제(일일/주간) 관리</li>
            <li>깐부(친구) 시스템을 통한 숙제 공유</li>
            <li>레이드 일정 관리</li>
            <li>큐브 계산기 및 기타 편의 기능</li>
            <li>커뮤니티 게시판</li>
            <li>구독 서비스 (광고 제거 및 프리미엄 기능)</li>
          </ul>
        </Section>

        <Section>
          <h3>제5조 (회원가입 및 탈퇴)</h3>
          <ul>
            <li>
              이용자는 서비스가 정한 절차에 따라 회원가입을 신청하며, 서비스는
              이를 승낙함으로써 이용 계약이 성립됩니다.
            </li>
            <li>
              회원은 언제든지 탈퇴를 요청할 수 있으며, 서비스는 즉시 처리합니다.
            </li>
            <li>
              탈퇴 시 회원의 데이터는 관련 법령에 따른 보관 기간을 제외하고 즉시
              삭제됩니다.
            </li>
          </ul>
        </Section>

        <Section>
          <h3>제6조 (구독 서비스 및 결제)</h3>
          <ul>
            <li>
              구독 서비스는 월 정기결제 방식으로 제공되며, 이용 요금은 서비스
              내에 별도로 표시합니다.
            </li>
            <li>
              결제는 신용카드, 체크카드 등 서비스가 지원하는 결제 수단을 통해
              이루어집니다.
            </li>
            <li>
              구독은 매월 자동으로 갱신되며, 이용자가 해지하지 않는 한
              계속됩니다.
            </li>
            <li>
              결제 실패 시 서비스는 일정 기간 재시도하며, 계속 실패할 경우 구독이
              만료될 수 있습니다.
            </li>
          </ul>
        </Section>

        <Section>
          <h3>제7조 (구독 해지)</h3>
          <ul>
            <li>
              이용자는 언제든지 구독을 해지할 수 있으며, 해지 시 다음 결제일부터
              결제가 중단됩니다.
            </li>
            <li>
              해지 후에도 이미 결제된 기간까지는 서비스 혜택이 유지됩니다.
            </li>
          </ul>
        </Section>

        <Section>
          <h3>제8조 (환불 정책)</h3>
          <ul>
            <li>
              구독 결제 후 서비스를 이용하지 않은 경우, 결제일로부터 7일 이내에
              전액 환불을 요청할 수 있습니다.
            </li>
            <li>
              서비스를 이용한 경우(로그인 후 광고 제거 혜택 적용 등), 이용
              일수를 차감한 잔여 금액을 환불합니다.
            </li>
            <li>
              환불 요청은 이메일(repeat2487@gmail.com)로 접수하며, 접수 후 영업일
              기준 3일 이내에 처리됩니다.
            </li>
            <li>
              결제 대행사(PG사) 수수료가 발생한 경우 해당 금액은 환불 금액에서
              차감될 수 있습니다.
            </li>
            <li>
              이용자의 귀책 사유로 인한 서비스 이용 제한의 경우 환불이 제한될 수
              있습니다.
            </li>
          </ul>
        </Section>

        <Section>
          <h3>제9조 (서비스 중단)</h3>
          <p>
            서비스는 시스템 점검, 장애, 천재지변 등 불가피한 사유로 일시적으로
            중단될 수 있으며, 사전에 공지합니다. 다만, 긴급한 경우 사후
            공지합니다.
          </p>
        </Section>

        <Section>
          <h3>제10조 (이용자의 의무)</h3>
          <ul>
            <li>이용자는 관련 법령과 본 약관을 준수해야 합니다.</li>
            <li>
              타인의 정보를 도용하거나 서비스 운영을 방해하는 행위를 해서는 안
              됩니다.
            </li>
            <li>
              서비스를 통해 얻은 정보를 서비스의 사전 승낙 없이 상업적으로
              이용해서는 안 됩니다.
            </li>
          </ul>
        </Section>

        <Section>
          <h3>제11조 (면책사항)</h3>
          <ul>
            <li>
              서비스는 무료 서비스 및 이용자 제공 데이터에 대해 책임을 지지
              않습니다.
            </li>
            <li>
              게임사(스마일게이트 RPG)의 API 변경 등 외부 요인으로 인한 서비스
              장애에 대해 책임을 지지 않습니다.
            </li>
          </ul>
        </Section>

        <Section>
          <h3>제12조 (분쟁 해결)</h3>
          <p>
            서비스 이용과 관련한 분쟁은 대한민국 법령에 따르며, 관할 법원은
            서비스 제공자의 소재지를 관할하는 법원으로 합니다.
          </p>
        </Section>

        <Section>
          <h3>사업자 정보</h3>
          <ul>
            <li>상호: 로아투두(LOATODO)</li>
            <li>대표자: 이민혁</li>
            <li>사업자등록번호: 853-27-01939</li>
            <li>주소: 인천광역시 부평구 갈월서로 46</li>
            <li>전화: 010-2427-2487</li>
            <li>이메일: repeat2487@gmail.com</li>
          </ul>
        </Section>

        <Section>
          <p>
            <strong>부칙</strong>
          </p>
          <p>본 약관은 2025년 4월 5일부터 시행합니다.</p>
        </Section>
      </PolicyCard>
    </WideDefaultLayout>
  );
};

export default TermsOfService;
